import { render, staticRenderFns } from "./monitors-children.vue?vue&type=template&id=03728c9e&"
import script from "./monitors-children.vue?vue&type=script&lang=js&"
export * from "./monitors-children.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports